var module = angular.module('octopusApp.environments');

module.controller('ProxyIndexController', function($scope, busy, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();
  isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status) {
    isLoading.promise(octopusRepository.Proxies.list().then(function (results) {
      $scope.proxies = results;
    }));
  }));
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/proxies/controllers/proxy_index_controller.js
// module id = 8741021649684
// module chunks = 1